function Main({ children }) {
    return <main id='home-screen'>{children}</main>;
}

export default Main;
